import * as React from "react"
import { PostItemsStyles } from "./PostStyles"

const PostItems = ({ children }) => {
  return <PostItemsStyles>{children}</PostItemsStyles>
}

export default PostItems
